module.exports = __webpack_public_path__ + "static/img/COC2023-5.4b91085.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-5.png
// module id = nOfM
// module chunks = 0